import { List, Map } from 'immutable';
import { records as jobsRecords } from '@saucelabs/sl-module-jobs';

import * as types from './types';
import { types as filterTypes } from './../filters';
import {
  DEFAULT_CLOUD_TYPE,
  DEFAULT_PAGE,
  DEFAULT_PAGE_SIZE,
  LS_LAST_MANUAL_CLOUD_TYPE,
} from './constants';

export const initialState = Map({
  cloudType: window.localStorage.getItem(LS_LAST_MANUAL_CLOUD_TYPE) || DEFAULT_CLOUD_TYPE,
  manual: List(), // this holds manual VDC jobs
  manualLoading: true,
  page: DEFAULT_PAGE,
  perPage: DEFAULT_PAGE_SIZE,
  rdc: List(),
  rdcError: {},
  rdcLoading: true,
  totalJobs: 0,
});

const toggleLoader = (mutable, newValue) => (
  mutable
    .set('manualLoading', newValue)
    .set('rdcLoading', newValue)
);

const flatManualReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case types.ARCHIVED_RDC_JOBS_GET.SUCCESS: {
      const jobs = payload.jobs
        ?.map((job) => new jobsRecords.RdcJobRecord({
          ...job,
          // NOTE: Archived jobs have a slightly different shape than resto jobs
          // so do some normalization here.
          assigned_tunnel_id: job.tunnel_id,
          automation_backend: null,
          browser: job.browser_name?.toLowerCase(),
          build: job.build_name,
          device_name: job.device,
          manual: job.run_mode === 'manual',
          // NOTE: creation_time is not exactly the same time as start_time, but
          // this is currently the only one available
          start_time: job.creation_time,
          status: (job.status === 'in progress' ? 'running' : job.status),
        }));

      return state.withMutations((mutable) => (
        mutable
          .set('rdc', List(jobs))
          .set('rdcLoading', false)
          .set('totalJobs', payload.total)
      ));
    }

    case types.ARCHIVED_VDC_JOBS_GET.SUCCESS: {
      const jobs = payload.jobs
        ?.map((job) => new jobsRecords.JobRecord({
          ...job,
          // NOTE: Archived jobs have a slightly different shape than resto jobs
          // so do some normalization here.
          assigned_tunnel_id: job.tunnel_id,
          browser: job.browser_name?.toLowerCase(),
          build: job.build_name,
          manual: job.run_mode === 'manual',
          // NOTE: using a string template causes an eslint error that requires a package update:
          // see: https://github.com/eslint/eslint/issues/13542
          // eslint-disable-next-line prefer-template
          os: job.os + ' ' + job.os_version,
          status: (job.status === 'in progress' ? 'running' : job.status),
        }));

      return state.withMutations((mutable) => (
        mutable
          .set('manual', List(jobs))
          .set('manualLoading', false)
          .set('totalJobs', payload.total)
      ));
    }

    case types.CHANGE_PAGE:
      return state.withMutations((mutable) => {
        mutable.set('page', payload);
        toggleLoader(mutable, true);
      });
    case types.CHANGE_PER_PAGE:
      return state.withMutations((mutable) => {
        mutable.set('perPage', payload);
        mutable.set('page', 1);
        toggleLoader(mutable, true);
      });
    case types.RESET_PAGE:
      return state.withMutations((mutable) => {
        mutable.set('page', initialState.get('page'));
        toggleLoader(mutable, true);
      });
    case filterTypes.CLEAR_OWNER:
    case filterTypes.CLEAR_STATUSES:
    case filterTypes.SELECT_OWNER:
    case filterTypes.TOGGLE_STATUS:
      return state.withMutations((mutable) => toggleLoader(mutable, true));
    case types.SET_CLOUD_TYPE: {
      window.localStorage.setItem(LS_LAST_MANUAL_CLOUD_TYPE, payload);
      return state.set('cloudType', payload);
    }
    case types.CLEANUP:
      return state.withMutations((mutable) => (
        mutable
          .set('manual', initialState.get('manual'))
          .set('manualLoading', initialState.get('manualLoading'))
          .set('rdc', initialState.get('rdc'))
          .set('rdcLoading', initialState.get('rdcLoading'))
      ));
    default:
      return state;
  }
};

export default flatManualReducer;
